import { render, staticRenderFns } from "./infoPublish.vue?vue&type=template&id=aa112fae"
import script from "./infoPublish.vue?vue&type=script&lang=js"
export * from "./infoPublish.vue?vue&type=script&lang=js"
import style0 from "./infoPublish.vue?vue&type=style&index=0&id=aa112fae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports